import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import { makeStyles } from '@material-ui/core/styles';
import InputLabel from '@material-ui/core/InputLabel';
import MenuItem from '@material-ui/core/MenuItem';
import FormControl from '@material-ui/core/FormControl';
import Select from '@material-ui/core/Select';

const useStyles = makeStyles(theme => ({
    root: {
        display: 'flex',
        flexWrap: 'wrap',
    },
    formControl: {
        margin: theme.spacing(1),
        minWidth: 80,
    },
    selectEmpty: {
        marginTop: theme.spacing(2),
    },
}));

const BudgetYears = props => {
    const { getBudgetYearValue } = props;
    const classes = useStyles();
    const [monthValues, setMonthValues] = useState({
        value: Number(new Date().getMonth()) + 1,
    });
    const [yearValues, setYearValues] = useState({
        value: new Date().getFullYear(),
    });

    const [months] = useState([
        { value: '1', Text: 'มกราคม' },
        { value: '2', Text: 'กุมภาพันธ์' },
        { value: '3', Text: 'มีนาคม' },
        { value: '4', Text: 'เมษายน' },
        { value: '5', Text: 'พฤษภาคม' },
        { value: '6', Text: 'มิถุนายน' },
        { value: '7', Text: 'กรกฎาคม' },
        { value: '8', Text: 'สิงหาคม' },
        { value: '9', Text: 'กันยายน' },
        { value: '10', Text: 'ตุลาคม' },
        { value: '11', Text: 'พฤศจิกายน' },
        { value: '12', Text: 'ธันวาคม' },
    ]);
    const getyearSelect = () => {
        let yearlist = [];
        for (let index = Number(new Date().getFullYear()) - 3; index <= Number(new Date().getFullYear() + 1); index++) {
            yearlist.push({ value: index.toString(), Text: (Number(index) + 543).toString() })
        }
        return yearlist;
    }
    const [years] = useState(getyearSelect());

    useEffect(() => {
        getBudgetYearValue(`${yearValues.value}-${monthValues.value}-01`)
    }, []);

    const handleChangeMonth = name => event => {
        setMonthValues({ ...monthValues, [name]: event.target.value });
        getBudgetYearValue(`${yearValues.value}-${event.target.value}-01`)
    };

    const handleChangeYear = name => event => {
        setYearValues({ ...yearValues, [name]: event.target.value });
        getBudgetYearValue(`${event.target.value}-${monthValues.value}-01`)
    };

    return (
        <form className={classes.root} autoComplete="off">
            <FormControl className={classes.formControl}>
                <InputLabel htmlFor="age-simple">เดือน</InputLabel>
                <Select
                    value={monthValues.value}
                    onChange={handleChangeMonth('value')}
                >
                    {
                        months.map((month, i) =>
                            <MenuItem key={i} value={month.value}>{month.Text}</MenuItem>
                        )
                    }
                </Select>
            </FormControl>
            <FormControl className={classes.formControl}>
                <InputLabel htmlFor="age-helper">ปี</InputLabel>
                <Select
                    value={yearValues.value}
                    onChange={handleChangeYear('value')}
                >
                    {
                        years.map((year, i) =>
                            <MenuItem key={i} value={year.value}>{year.Text}</MenuItem>
                        )
                    }
                </Select>
            </FormControl>
        </form>
    );
}
BudgetYears.propTypes = {
    getBudgetYearValue: PropTypes.func
};

export default BudgetYears;
